module.exports = __webpack_public_path__ + "static/LoginIcon-58e5aded6d92b452859c1c9306b824f4.png";